module.exports = __webpack_public_path__ + "static/media/oppløsning.62ff61af.m4a";